import { render, staticRenderFns } from "./bulkintransit.vue?vue&type=template&id=638e37e3"
import script from "./bulkintransit.vue?vue&type=script&lang=js"
export * from "./bulkintransit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports